<template>
  <div>
    <!--设置网址title-->
    <div v-wechat-title="$route.meta.title='理捷管理系统'"></div>
    <!--返回上一页-->
    <div class="backBg">
      <a href="javascript:history.go(-1)">
        <div class="backBox">
          <span class="backIcon"></span>
        </div>
      </a>
      <div class="topTitle">
        <span >仓库查询</span>
      </div>
    </div>
    <div class="content_bg">
      <div class="o_blue_box">
        <!--当日总数-->
        <div class="check_list_bg" style="padding-top: 0.5rem">
          <div class="check_list_box">
            <div class="check_list_w" style="overflow: hidden">
              <!--针车入库总数-->
              <div class="count_box gary_line" @click="jumpDepotDetail(1)">
                <p>针车库总数</p>
                <p>{{ count_data.part1_count }}件</p>
              </div>
              <!--成型入库总数-->
              <div class="count_box gary_line" @click="jumpDepotDetail(2)">
                <p>成型库总数</p>
                <p>{{ count_data.part2_count }}件</p>
              </div>
              <!--成品入库总数-->
              <div class="count_box" @click="jumpDepotDetail(3)">
                <p>成品入库总数</p>
                <p>{{ count_data.part3_count }}件</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { webToast } from "@/assets/js/alertPopShow";
  import loading from '@/components/loading'
  export default {
    name:'orderCheck',
    components:{
      loading,
    },
    data(){
      return{
        list:'',
        depotList:['针车中仓','成型中仓','成品仓'],
        count_data:'',
        loading:false,
      }
    },
    created:function () {
      var that = this;
      var token = localStorage.getItem('token');
      var formData = new FormData();
      formData.append('token',token);
      that.app.postData('/mhome.php/Count/searchOrderByPart',formData
        ,result =>{
          that.count_data = result.content.count_data;
        })
      //    配置微信jssdk
      var url = window.location.href.split('#')[0];
      that.app.wxjssdk(url);
    },
    methods:{
//      点击搜索框
      clickSearch(){
        this.$refs.searchBar.classList.add('weui-search-bar_focusing');
        this.selDepot();
      },
//      选择日期
      selDepot(){
        var sel_date = this.$refs.sel_date;
        var searchSubmit = this.$refs.searchSubmit;
        var searchClear = this.$refs.searchClear;
        weui.picker( this.depotList ,{
          onChange:function (result) {

          },
          onConfirm: function (result) {
            sel_date.value = result[0];
            searchSubmit.innerHTML = '搜索';
            searchClear.style.display = 'block';
          },
        })
      },
//      取消搜索
      cancelSearch(){
        this.$refs.searchBar.classList.remove('weui-search-bar_focusing');
        this.$refs.sel_date.blur();
      },
//      清除搜索内容
      clearSearch(){
//        this.$refs.sel_date.focus();
        this.$refs.sel_date.value = '';
        this.$refs.searchClear.style.display = 'none';
        this.$refs.searchSubmit.innerHTML = '取消';
      },
//      搜索框失去焦点
      blurSearch(){
        if(!this.$refs.sel_date.value.length){
          this.cancelSearch();
          this.$refs.searchSubmit.innerHTML = '取消';
        }
      },
//      监听搜索
      checkSearch(){
        if(this.$refs.sel_date.value.length){
          this.$refs.searchSubmit.innerHTML = '搜索';
        }
      },
//      点击搜索
      search(){
        if(this.$refs.sel_date.value.length){
          console.log(this.$refs.sel_date.value);
          var that = this;
          var token = localStorage.getItem('token');
          var date = that.thisDate;
          var formData = new FormData();
          formData.append('token',token);
          formData.append('order_id',order_id);
          formData.append('type',type);
          if( num > 0 ){
            that.$router.push({ name:'codeDetail',query:{ order_id:order_id,type:type,date:date } });
            return false;
          }else{
            webToast('暂无数据','middle',1500);
          }
        }else{
          this.cancelSearch();
        }
      },
//      展开列表
      getMore(index){
        var get_more = this.$refs.get_more[index];
        if(get_more.classList[1] == 'get_more_arr'){
          get_more.classList.remove('get_more_arr');
          get_more.classList.add('get_more_arr2');
          get_more.innerHTML = '收起';
        }else{
          get_more.classList.remove('get_more_arr2');
          get_more.classList.add('get_more_arr');
          get_more.innerHTML = '查看更多';
        }
      },
//      查看仓库详情
      jumpDepotDetail(type){
        var that = this;
        that.$router.push({ name:'depotDetail',query:{ type:type } })
      }
    },
    beforeRouteEnter(to,from,next){
      if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
        if (to.path !== location.pathname) {
          // 此处不可使用location.replace
          location.assign(to.fullPath)
        } else {
          next()
        }
      }else{
        next();
      }
    },
    beforeRouteLeave(to,from,next){
      window.document.body.style.background = '';
      next();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/depotCheck.vue